import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../../textBoxWithTooltip';
import Row from './row';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: primary.white,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${primary.bluish7}`,
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 4,
    position: 'sticky',
    top: 0,
    left: 0,
    paddingBottom: spacing(4),
    height: 41,
    minWidth: '100%',
    zIndex: 20,
  },
  rolesHeaderCell: {
    background: primary.white,
    position: 'sticky',
    top: 0,
    left: 0,
    width: 300,
    zIndex: 30,
  },
  headerCell: {
    display: 'flex',
    flexDirection: 'column',
    width: 90,
    height: '100%',
  },
  headerTop: {
    display: 'flex',
    justifyContent: 'center',
    gap: 4,
  },
  expandableScopeHeaderCell: {
    width: 180,
  },
  scopeSettings: {
    display: 'flex',
    justifyContent: 'center',
    gap: 4,
  },
  scope: {
    flexShrink: 0,
    textAlign: 'center',
    width: 40,
  },
  roleName: {
    textAlign: 'center',
    lineHeight: '24px',
  },
  permissionGroups: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const PermissionsForm = ({
  translations,
  roles,
  permissionGroups,
  permissionsByRole,
  expandedGroup,
  onToggleGroup,
  onTogglePermission,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.rolesHeaderCell} variant="body2">
          {translations.modules}
        </Typography>
        {roles.map(role => (
          <div
            key={`hrole_${role.id}`}
            className={classNames(classes.headerCell, {
              [classes.expandableScopeHeaderCell]:
                role.hasPermissionsWithMultipleScopes,
            })}
          >
            <div className={classes.headerTop}>
              {role.isAdditionalRole ? (
                <TextBoxWithTooltip
                  className={classes.roleName}
                  variant="body2"
                  text={role.name}
                />
              ) : (
                <Typography className={classes.roleName} variant="body2">
                  {role.label}
                </Typography>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className={classes.permissionGroups}>
        {permissionGroups.map(permissionGroup => (
          <Row
            key={`permissions_group_${permissionGroup.group}`}
            translations={translations}
            roles={roles}
            permissionGroup={permissionGroup}
            permissionsByRole={permissionsByRole}
            isExpanded={expandedGroup === permissionGroup.group}
            onToggleExpand={onToggleGroup}
            onTogglePermission={onTogglePermission}
          />
        ))}
      </div>
    </div>
  );
};

PermissionsForm.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  permissionGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  permissionsByRole: PropTypes.object.isRequired,
  expandedGroup: PropTypes.string.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  onTogglePermission: PropTypes.func.isRequired,
};

export default PermissionsForm;
